module.exports = __webpack_public_path__ + "img/primarLoading.d7507f89.gif";